import React from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'view-components/utilities/intl';

import UpperSectionAlert from 'view-components/components/Dialog/UpperSection/Alert';
import { LowerSectionText } from 'view-components/components/Dialog/Components';

import LowerSectionDeleteConfirm from './Components/LowerSectionDeleteConfirm';
import confirmableDialog from './Components/ConfirmableDialog';
import { DialogProps } from 'global/types';

interface Props extends DialogProps {
  deleteName: string
}

function LowerContent() {
  return (
    <LowerSectionText>
      <FormattedHTMLMessage
        id="app.dialog.delete_user.lower_section"
      />
    </LowerSectionText>
  );
}

function DeleteUserDialogContentFn(props: Props) {
  const {
    deleteName = null,
    isConfirmed = null,
    onConfirm = () => {},
    onDismiss = () => {},
    toggleConfirmed = () => {},
  } = props;

  return (
    <div>
      <UpperSectionAlert>
        <FormattedHTMLMessage
          id="app.dialog.delete_user.message"
          values={{ firstName: deleteName }}
        />

      </UpperSectionAlert>

      <LowerSectionDeleteConfirm
        toggleConfirmed={toggleConfirmed}
        isConfirmed={isConfirmed}
        deleteMessage={
          <FormattedHTMLMessage
            id="app.dialog.delete_user.confirm"
          />
        }
        onConfirm={onConfirm}
        additionalTopContent={<LowerContent />}
        onDismiss={onDismiss}
      />
    </div>
  );
}

DeleteUserDialogContentFn.propTypes = {
  deleteName: PropTypes.string,
  isConfirmed: PropTypes.bool,
  onConfirm: PropTypes.func,
  onDismiss: PropTypes.func,
  toggleConfirmed: PropTypes.func,
};

const DeleteUserDialogContent = confirmableDialog(DeleteUserDialogContentFn);

export default DeleteUserDialogContent;
